<template>
  <div class="box">
    <van-form @submit="onSubmit">
      <van-field
        v-model="deviceName"
        name="设备名称"
        label="设备名称"
        placeholder="请输入设备名称"
      />
      <van-field
        v-model="deviceNum"
        name="设备编号"
        label="设备编号"
        placeholder="请输入设备底部编号(S/N)"
      />
      <van-field
        v-model="deviceKey"
        name="设备秘钥"
        label="设备秘钥"
        placeholder="请输入设备底部秘钥(key)"
      />
      <van-field
        v-model="printNum"
        name="打印数量"
        label="打印数量"
        placeholder="(张)"
      />
      <div class="order">
        <span style="margin-right: 40px">订单归属</span>
        <span>店铺全部订单</span>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { request1 } from "@/utils/https";
import { Toast } from "vant";
export default {
  name: "ticket",
  data() {
    return {
      deviceName: "",
      deviceNum: "",
      deviceKey: "",
      printNum: "",
    };
  },
  methods: {
    async onSubmit() {
        let data = {
          name: this.deviceName,
          printer_sn: this.deviceNum,
          printer_key: this.deviceKey,
          quantity: this.printNum,
          print_support: ['2'],
          industry_id: 1,
          industry_level_id: 8
        };
        let res = await request1(
          "printers/manager/save",
          data
        );
        if(res.error == 0) {
            Toast(res.error_reason)
            this.$router.go(-1)
        } else {
            Toast(res.error_reason)
        }
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.order {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}
</style>
